
import React, { useState, useEffect } from "react"
import ReactFontLoader from "react-font-loader"
import { useAppCtx, appStore } from "lib/state"
import { appTools, cn } from "lib/utils"
import { useRenderStyling } from "lib/hooks/useRenderStyling"
import { useTemplatePreviewCtx } from "lib/units/template/preview/TemplatePreviewProvider"
import TemplateEditingConsole from "lib/units/template/preview/TemplateEditingConsole"

import TopbarRender from "lib/units/element/Topbar/TopbarRender"
import TitleBlockRender from "lib/units/element/TitleBlock/TitleBlockRender"
import TrxHistoryTableRender from "lib/units/element/TrxHistoryTable/TrxHistoryTableRender"
import DetailScreensRender from "lib/units/element/DetailScreens/DetailScreensRender"
import CompellingEvidenceRender from "lib/units/element/CompellingEvidence/CompellingEvidenceRender"
import SupportingImagesRender from "lib/units/element/SupportingImages/SupportingImagesRender"
import LetterPrefixRender from "lib/units/element/LetterPrefix/LetterPrefixRender"
import SummaryTableRender from "lib/units/element/SummaryTable/SummaryTableRender"
import SummaryBlockRender from "lib/units/element/SummaryBlock/SummaryBlockRender"
import {StatementsRender} from "lib/units/element/Statement/rendering"
import PoliciesRender from "lib/units/element/Policies/PoliciesRender"
import LetterClosingRender from "lib/units/element/LetterClosing/LetterClosingRender"
import DisclaimerRender from "lib/units/element/Disclaimer/DisclaimerRender"

import ImageManager from "lib/modules/ImageManager/ImageManager"

export default function TemplatePreview({
  mode="render",
}:{
  mode?:string
}){

  const { renderconfig }:any = useTemplatePreviewCtx()

  const { store, AppStore }:any = appStore()
  const { update } = AppStore

  const width = `w-[${renderconfig?.width}px]`

  const designWrapper = useRenderStyling(cn("mm-design-defleppard bg-white flex flex-col mt-auto mb-auto pt-3 pb-3 overflow-x-hidden", width), "styleObj")
  const outerWrapper = useRenderStyling("w-full flex flex-col pl-4 pr-4 pt-2 pb-2", "styleObj")
  const headerWrapper = useRenderStyling("w-full flex justify-between mt-6 pr-6", "styleObj")
  const headerLeft = useRenderStyling("w-10/24 flex flex-col", "styleObj")
  const headerRight = useRenderStyling("w-12/24 flex flex-col items-end", "styleObj")
  const logoWrapper = useRenderStyling("w-20/24 flex flex-col items-end", "styleObj")
  const logoStyle = useRenderStyling("w-22/24 mb-4", "styleObj")

  // useEffect(() => {
  //   `render config width: ${renderconfig?.width}`
  // },[renderconfig])

  return (
    <div className="w-[98%] h-[calc(100vh-11rem)] overflow-y-auto scrollbar">
      <div 
        id="mm-pdf-render" 
        {...designWrapper}
        // className={cn("mm-design-defleppard bg-white flex flex-col mx-auto py-3 mx-10 overflow-x-hidden")}
        // style={{
        //   marginLeft: "auto",
        //   marginRight: "auto",
        //   width: renderconfig?.width || "920px",
        // }}
      >
        <div {...outerWrapper}>

        {/* { store.preview.editors === true && (
            <TemplateEditingConsole  />
          )} */}
      
          {/* topbar  */}
          <TopbarRender />
          
          {/* header */}  
          <div {...headerWrapper}>
            <div {...headerLeft}>
              <TitleBlockRender />
              <SummaryTableRender />
            </div>

            <div {...headerRight}>  
              <div {...logoWrapper}>
                <div {...logoStyle}>
                  <img src="https://acme.midmetrics.io/images/MM-Logo-Final-Black.svg" alt="Midmetrics Logo" />
                </div>
                <SummaryBlockRender />
              </div>
            </div>
          </div>
          {/* end of header  */} 
      
    
          <div>
            <LetterPrefixRender />
            <StatementsRender elemtype="opening_statements" />
          </div>
      
          <TrxHistoryTableRender />

          <SupportingImagesRender />
  
          <StatementsRender elemtype="compelling_evidence" />

          <DetailScreensRender />

          <PoliciesRender />

          <LetterClosingRender />

          <DisclaimerRender />
  
        </div>
      </div>
    </div>
  )
}